import * as requestApi from "./request";
import * as requestSystemApi from "./requestSystem";
import OSS from "ali-oss";

let client = new OSS({
  region: "oss-cn-hangzhou",
  accessKeyId: "LTAIAFEe1m0izOBK",
  accessKeySecret: "R0NSWCfSHJGYWH6zW9H8Pc9Upma3Zk",
  bucket: "ggyp-source"
});

export default {
  queryPurchaseOrder: params =>
    requestApi.postAixos("/api/scm/purchase/order/queryPurchaseOrder", params),
  pagePurchaseOrderGoodsList: params =>
    requestApi.postAixos(
      "/api/scm/purchase/order/pagePurchaseOrderGoodsList",
      params
    ),
  queryDeliveryList: params =>
    requestApi.postAixos("/api/scm/purchase/order/queryDeliveryList", params),
  loginDing: params =>
    requestSystemApi.postAixos("/api/scm/user/loginDing", params),
  getMenus: params => requestApi.postAixos("/api/scm/user/permission", params),
  getSendOrderList: params =>
    requestApi.postAixos("/api/scm/send/order/queryList", params),
  querySendOrder: params =>
    requestApi.postAixos("/api/scm/send/order/querySendOrder", params),
  receiveSendOrder: params =>
    requestApi.postAixos("/api/scm/send/order/receiveSendOrder", params),
  updateSendOrder: params =>
    requestApi.postAixos("/api/scm/send/order/updateSendOrder", params),
  queryQualityOrderList: params =>
    requestApi.postAixos("/api/scm/quality/order/queryList", params),
  queryQualityOrder: params =>
    requestApi.postAixos("/api/scm/quality/order/queryQualityOrder", params),
  submitQualityOrder: params =>
    requestApi.postAixos(
      "/api/scm/quality/order/spotcheck/submitQualityOrder",
      params
    ),
  updateQualityOrder: params =>
    requestApi.postAixos(
      "/api/scm/quality/order/spotcheck/updateQualityOrder",
      params
    ),
  updateComQualityOrder: params =>
    requestApi.postAixos("/api/scm/quality/order/updateQualityOrder", params),
  queryQualityOrderByColor: params =>
    requestApi.postAixos(
      "/api/scm/quality/order/spotcheck/queryQualityOrderByColor",
      params
    ),
  querySpotcheckList: params =>
    requestApi.postAixos("/api/scm/quality/order/spotcheck/queryList", params),
  wechatAccess: params =>
    requestSystemApi.postAixos("/api/wechat/access", params),
  wechatRelatedUser: params =>
    requestSystemApi.postAixos("/api/wechat/relatedUser", params),
  updateQualityNum: params =>
    requestApi.postAixos("/api/scm/quality/order/updateQualityNum", params),
  // submitQualityOrder: (params) => requestApi.postAixos('/quality/order/spotcheck/submitQualityOrder', params),
  queryQualityOrderResult: params =>
    requestApi.postAixos(
      "/api/scm/quality/order/spotcheck/queryQualityOrderResult",
      params
    ),
  aduitQualityOrder: params =>
    requestApi.postAixos("/api/scm/quality/order/aduitQualityOrder", params),
  queryQualityOrderDetail: params =>
    requestApi.postAixos(
      "/api/scm/quality/order/queryQualityOrderDetail",
      params
    ),
  clearQualityOrderResult: params =>
    requestApi.postAixos(
      "/api/scm/quality/order/spotcheck/clearQualityOrderResult",
      params
    ),
  unAuditQuality: params =>
    requestApi.postAixos("/api/scm/quality/order/unAuditQuality", params),
  cancelQualityOrder: params =>
    requestApi.postAixos("/api/scm/quality/order/cancelQualityOrder", params),
  queryQualityOrderReportMsg: params =>
    requestApi.postAixos(
      "/api/scm/quality/order/spotcheck/queryQualityOrderReportMsg",
      params
    ),
  genQualityOrderReportMsg: params =>
    requestApi.postAixos(
      "/api/scm/quality/order/spotcheck/genQualityOrderReportMsg",
      params
    ),
  queryPurchaseList: params =>
    requestApi.postAixos("/api/scm/purchase/order/query/list", params),
  orderProgress: params =>
    requestApi.postAixos("/api/scm/purchase/order/orderProgress", params),
  baseExpress: params =>
    requestApi.postAixos("/api/scm/send/order/baseExpress", params),
  querySendGoodsInfo: params =>
    requestApi.postAixos("/api/scm/send/order/querySendGoodsInfo", params),
  getSendOrderSn: params =>
    requestApi.postAixos("/api/scm/send/order/getSendOrderSn", params),
  // pagePurchaseOrderGoodsList: (params) => requestApi.postAixos('/purchase/order/pagePurchaseOrderGoodsList', params),
  createSendOrder: params =>
    requestApi.postAixos("/api/scm/send/order/create", params),
  // updateSendOrder: (params) => requestApi.postAixos('/send/order/updateSendOrder', params),
  submitSendOrder: params =>
    requestApi.postAixos("/api/scm/send/order/submitSendOrder", params),
  queryStockInReportList: params =>
    requestApi.postAixos("/api/scm/stockIn/msg/queryStockInReportList", params),
  // querySendOrder: (params) => requestApi.postAixos('/send/order/querySendOrder', params),
  querySendOrderByColor: params =>
    requestApi.postAixos("/api/scm/send/order/querySendOrderByColor", params),
  querySendOrderDetail: params =>
    requestApi.postAixos("/api/scm/send/order/querySendOrderDetail", params),
  updateSendOrderDetail: params =>
    requestApi.postAixos("/api/scm/send/order/updateSendOrderDetail", params),
  queryPurchaseContract: params =>
    requestApi.postAixos(
      "/api/scm/purchase/contract/queryPurchaseContract",
      params
    ),
  queryPaymentQueryList: params =>
    requestApi.postAixos("/api/scm/purchase/order/query/list", params),
  queryPaymentTypeList: params =>
    requestApi.postAixos(
      "/api/scm/purchase/order/queryPaymentTypeList",
      params
    ),
  queryPurchaseOrderGoodsList: params =>
    requestApi.postAixos(
      "/api/scm/purchase/order/queryPurchaseOrderGoodsList",
      params
    ),
  queryPurchaseOrderAudit: params =>
    requestApi.postAixos("/api/scm/purchase/order/audit", params),
  queryOrderQualityResultReason: params =>
    requestApi.postAixos(
      "/api/scm/quality/order/queryQualityResultReason",
      params
    ),
  queryPlanList: params =>
    requestApi.postAixos("/api/scm/purchase/plan/order/query/list", params),
  purchaseUpdate: params =>
    requestApi.postAixos("/api/scm/purchase/plan/order/update", params),
  purchaseAudit: params =>
    requestApi.postAixos("/api/scm/purchase/plan/order/audit", params),
  queryPurchasePlan: params =>
    requestApi.postAixos(
      "/api/scm/purchase/plan/order/queryPurchasePlan",
      params
    ),
  queryDetailList: params =>
    requestApi.postAixos(
      "/api/scm/purchase/plan/order/queryDetailList",
      params
    ),
  updateDetail: params =>
    requestApi.postAixos("/api/scm/purchase/plan/order/updateDetail", params),
  optionSupplierList: params =>
    requestApi.postAixos("/api/scm/option/supplier/list", params),
  manageList: params =>
    requestApi.postAixos("/api/scm/manage/dept/user/list", params),
  purchasePlanSave: params =>
    requestApi.postAixos("/api/scm/purchase/plan/order/issue/save", params),
  purchasePlanOrderIssue: params =>
    requestApi.postAixos("/api/scm/purchase/plan/order/issue", params),
  purchasePlanDetail: params =>
    requestApi.postAixos(
      "/api/scm/purchase/plan/order/issue/query/detail",
      params
    ),
  queryTotal: params =>
    requestApi.postAixos("/api/scm/purchase/plan/order/queryTotal", params),
  supplierPage: params =>
    requestApi.postAixos("/api/scm/supplier/page", params),
  getOptions: params => requestApi.getAxios("/api/scm/option/query", params),
  getMangeSearchDefault: params =>
    requestApi.postAixos("/api/scm/manage/search/default", params),
  getSampleinfoQueryList: params =>
    requestApi.postAixos(
      "/api/scm/sample/select/sampleinfo/query/detail/list",
      params
    ),
  createMocileSample: params =>
    requestApi.postAixos("/api/scm/sample/select/mobile/create", params),
  getSampleSelectMobileQueryList: params =>
    requestApi.postAixos("/api/scm/sample/select/mobile/query/list", params),
  getSampleSelectProductDetailList: params =>
    requestApi.postAixos(
      "/api/scm/sample/select/mobile/product/detail/list",
      params
    ),
  getSampleSelectProductDetailSave: params =>
    requestApi.postAixos(
      "/api/scm/sample/select/mobile/product/detail/save",
      params
    ),
  getSampleSelectProductDetailDelete: params =>
    requestApi.postAixos(
      "/api/scm/sample/select/mobile/product/detail/delete",
      params
    ),
  getSampleSelectSubmit: params =>
    requestApi.postAixos("/api/scm/sample/select/submit", params),
  getSampleSelectDeptView: params =>
    requestApi.postAixos("/api/scm/sample/select/mobile/dept/view", params),
  getSampleSelectProductList: params =>
    requestApi.postAixos(
      "/api/scm/sample/select/mobile/product/select/list",
      params
    ),
  getSampleSelectProductSelecting: params =>
    requestApi.postAixos(
      "/api/scm/sample/select/mobile/product/selecting",
      params
    ),
  getSampleSelectDeptConfirm: params =>
    requestApi.postAixos("/api/scm/sample/select/mobile/dept/confirm", params),
  getSampleSelectDeptSelectList: params =>
    requestApi.postAixos(
      "/api/scm/sample/select/mobile/dept/select/list",
      params
    ),
  getSampleSelectList: params =>
    requestApi.postAixos("/api/scm/option/department/list", params),
  getSampleMobileDeptSelected: params =>
    requestApi.postAixos("/api/scm/sample/select/mobile/dept/selected", params),
  getSampleMobileDeptDecete: params =>
    requestApi.postAixos("/api/scm/sample/select/mobile/dept/delete", params),
  getSampleMobileDeptOrderEnd: params =>
    requestApi.postAixos(
      "/api/scm/sample/select/mobile/dept/order/end",
      params
    ),
  tokenSTS: params => requestApi.postAixos("/api/scm/user/oss/role", params),
  getSampleMobileDeptView: params =>
    requestApi.postAixos("/api/scm/sample/select/mobile/dept/view", params)
};



// WEBPACK FOOTER //
// ./src/request/index.js